import React from "react";
import TitleImg from "../SessionExpired/img/title.svg";

const IframeErrorMessage: React.FC = () => {
  return (
    <div className="d-flex align-items-center justify-content-start bg-main-background min-vh-100 px-3 py-4 flex-column">
      <div
        className="rounded bg-white px-3 py-5 w-100 text-center"
        style={{ maxWidth: "636px" }}
      >
        <div className="row py-5">
          <div className="col-12 col-sm-8 m-auto">
            <img src={TitleImg} alt="Session Expired" />
            <div className="text-dark-gray fs-2 fw-bold mt-4 mb-3 lh-sm">Something went wrong</div>
            <div className="text-background-mobile mb-4 px-2">We’re working on it — please try again later.</div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default IframeErrorMessage;
